import { AutoAwesomeMosaic } from '@mui/icons-material';

import { basicRoles } from '@/router/consts';
import { sellerMap } from '@/router/managementMaps';

import type { SidebarMenu } from '../../types';

const dashboardMenus: SidebarMenu[] = [
  {
    title: sellerMap['dashboard'].title,
    path: sellerMap['dashboard'].path,
    icon: <AutoAwesomeMosaic />,
    roles: basicRoles,
  },
];

export default dashboardMenus;
